import {
  CardContainer,
  StyledDiv,
  StyledDivImage,
  Title,
} from "@c/activity-view/activities-list/ActivityCard/ActivityCard.styled";

export const PassageStyledDiv = StyledDiv.extend`
width:100%;
padding: 0.7rem;
display: flex;
flex-direction: column;
justify-content: center;
`
export const PassageTitle = Title.extend`
height: auto;
font-size: 1.2rem;
`
export const PassageCardContainer = CardContainer.extend`
cursor: pointer;
`